// import React, { useEffect, useState } from "react";
// import axios from "axios";

// const AdmitCards = () => {
//   const [data, setData] = useState([]);

//   useEffect(() => {
//     axios.get("https://script.google.com/macros/s/AKfycbxBZDHHll0w2hy-Gbpo0zgEDTHqboT-a-hUt2u9tof0oFTAY-X0tJqWBFZHIgG42dab/exec?sheet=AdmitCards")
//       .then(res => {
//         console.log("Admit Cards:", res.data);
//         setData(res.data);
//       })
//       .catch(err => console.error(err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//             <th>Details</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, idx) => (
//             <tr key={idx}>
//               <td>{item.ExamName}</td>
//               <td><a href={item.AdmitCardLink} target="_blank" rel="noopener noreferrer">Download Admit Card</a></td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default AdmitCards;









// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LatestJobs.css"; // reuse same styles

// const AdmitCards = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         // ✅ Only include jobs that actually have admit card data
//         const filtered = jobs.filter(job => job.admitCard && job.admitCard.length > 0);
//         setData(filtered);
//       })
//       .catch((err) => console.error(err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//             <th>Details</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 10).map((item, idx) => (
//             <tr key={idx}>
//               <td>{item.JobTitle}</td>
//               <td>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item._id}`);
//                   }}
//                 >
//                   Download Admit Card
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       {data.length > 10 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-admit-cards")}
//           >
//             See All Admit Cards
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdmitCards;





// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LatestJobs.css"; // reuse same styles

// const AdmitCards = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         // ✅ Filter only jobs that have admit cards
//         const filtered = jobs.filter(
//           (job) => job.admitCard && job.admitCard.length > 0
//         );

//         // ✅ Sort to bring most recently updated admit card job to top
//         const sorted = filtered.sort((a, b) => {
//           const aDate = new Date(a.admitCard?.[0]?.updatedAt || a.updatedAt || a.createdAt);
//           const bDate = new Date(b.admitCard?.[0]?.updatedAt || b.updatedAt || b.createdAt);
//           return bDate - aDate; // most recent first
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error(err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//             <th>Details</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 10).map((item, idx) => (
//             <tr key={idx}>
//               <td>{item.JobTitle}</td>
//               <td>
//                 <a
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item._id}`);
//                   }}
//                 >
//                   Download Admit Card
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       {data.length > 10 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-admit-cards")}
//           >
//             See All Admit Cards
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdmitCards;



// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import "./LatestJobs.css"; // ✅ Keep the same styling for consistency

// const AdmitCards = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         const filtered = jobs.filter(
//           (job) => job.admitCard && job.admitCard.length > 0
//         );

//         const sorted = filtered.sort((a, b) => {
//           const aLatest = Math.max(
//             ...a.admitCard.map((card) => new Date(card.updatedAt).getTime() || 0)
//           );
//           const bLatest = Math.max(
//             ...b.admitCard.map((card) => new Date(card.updatedAt).getTime() || 0)
//           );
//           return bLatest - aLatest;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch admit cards:", err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 15).map((item, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
//                 <a
//                   className="job-link"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item._id}`);
//                   }}
//                   style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                   }}
//                 >
//                   {item.JobTitle}
//                 </a>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length > 15 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-admit-cards")}
//           >
//             See All Admit Cards
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdmitCards;




// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
// import "./LatestJobs.css";

// const AdmitCards = () => {
//   const [data, setData] = useState([]);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
//     fetch(`${API_URL}/jobs`)
//       .then((res) => res.json())
//       .then((jobs) => {
//         console.log("Fetched Job admt card:", jobs);
//         const filtered = jobs.filter(
//           (job) => job.admitCard && job.admitCard.length > 0
//         );

//         // 🔽 Sort based on latest updatedAt inside admitCard array
//         const sorted = filtered.sort((a, b) => {
//           const aTime = Math.max(...a.admitCard.map(c => new Date(c.updatedAt || 0).getTime()));
//           const bTime = Math.max(...b.admitCard.map(c => new Date(c.updatedAt || 0).getTime()));
//           return bTime - aTime;
//         });

//         setData(sorted);
//       })
//       .catch((err) => console.error("Failed to fetch admit cards:", err));
//   }, []);

//   return (
//     <div className="table-card">
//       <h3 className="table-title">Admit Cards</h3>
//       <table className="styled-table">
//         <thead>
//           <tr>
//             <th>Exam</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.slice(0, 15).map((item, idx) => (
//             <tr key={idx}>
//               <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                 <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
//                 {/* <a
//                   className="job-link"
//                   href="#"
//                   onClick={(e) => {
//                     e.preventDefault();
//                     navigate(`/job/${item.slug}`);
//                   }}
//                   style={{
//                     textDecoration: "none",
//                     color: "#007bff",
//                   }}
//                 >
//                   {item.JobTitle}
//                 </a> */}

//                 <Link
//                 className="job-link"
//                 to={`/job/${item.slug}`}
//                 style={{
//                   textDecoration: "none",
//                   color: "#007bff",
//                 }}
//               >
//                 {item.JobTitle}
//               </Link>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       {data.length > 15 && (
//         <div style={{ textAlign: "right", marginTop: "1rem" }}>
//           <button
//             className="see-all-btn"
//             onClick={() => navigate("/all-admit-cards")}
//           >
//             See All Admit Cards
//           </button>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdmitCards;



import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./LatestJobs.css";

const AdmitCards = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const API_URL = process.env.REACT_APP_NODE_BACKEND_API_URL;
    fetch(`${API_URL}/jobs/admit-cards`)
      .then((res) => res.json())
      .then((jobs) => {
        // Sort by latest updatedAt in admitCard array
        const sorted = jobs.sort((a, b) => {
          const aTime = Math.max(
            ...a.admitCard.map((c) => new Date(c.updatedAt || 0).getTime())
          );
          const bTime = Math.max(
            ...b.admitCard.map((c) => new Date(c.updatedAt || 0).getTime())
          );
          return bTime - aTime;
        });
        setData(sorted);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to fetch admit cards:", err);
        setLoading(false);
      });
  }, []);

  return (
    <div className="table-card">
      <h3 className="table-title">Admit Cards</h3>
      <table className="styled-table">
        <thead>
          <tr>
            <th>Exam</th>
          </tr>
        </thead>
        <tbody>
          {loading
            ? // Skeleton loader with fixed height rows to prevent layout shifts
              Array(5)
                .fill(0)
                .map((_, idx) => (
                  <tr key={idx}>
                    <td style={{ height: "40px", backgroundColor: "#f0f0f0" }}></td>
                  </tr>
                ))
            : data.slice(0, 15).map((item, idx) => (
                <tr key={idx}>
                  <td style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <span style={{ color: "#000", fontSize: "20px", lineHeight: "1" }}>•</span>
                    <Link
                      className="job-link"
                      to={`/job/${item.slug}`}
                      style={{ textDecoration: "none", color: "#007bff" }}
                    >
                      {item.JobTitle}
                    </Link>
                  </td>
                </tr>
              ))}
        </tbody>
      </table>

      {/* Reserve space for the button to avoid layout shift */}
      <div style={{ textAlign: "right", marginTop: "1rem", minHeight: "50px" }}>
        {!loading && data.length > 15 && (
          <button className="see-all-btn" onClick={() => navigate("/all-admit-cards")}>
            See All Admit Cards
          </button>
        )}
      </div>
    </div>
  );
};

export default AdmitCards;
